import React from 'react'
import 'antd/dist/antd.css';
import { PAGE_COMPANY } from '../../config'
import Top from '../../components/common/TopBack/index'
import '../ApplyFor/index.scss'
import { Layout, Input, Button, Row, message, Typography, Table, Form, DatePicker, Tabs, Popconfirm, } from 'antd';
import {
    getTrialList
} from '../../utils/api'
import actionWays from "../../redux/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
const { TabPane } = Tabs;

const { Content } = Layout;
const { Title } = Typography;
class ApplyFor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newContent: {},
            pageContent: [],
            current: 1,
            status: '',
            loading: true,
            productName: '',
            regTime: '',
            updateConstructionVisible: false,
            constructionVisible: false,
            particularsVisible: false,
            particularsContent: {},
            updateConstructionContent: {},
        };
        this.industryNews = null
    }

    componentDidMount() {
        console.log(this.props.userLoginInfo);
        this.getPages()

    }
    getPages = async () => {
        this.setState({
            loading: true
        })
        let opt = {}
        const { current, status, productName, regTime } = this.state
        opt.pageIndex = current - 1,
            // opt.productName = productName,
            opt.regTime = regTime,
            opt.pageSize = 20,
            opt.status = status,
            opt.companyName = productName
        let data = await getTrialList(opt)
        if (data.code == 0) {
            this.setState({
                newContent: data.data,
                pageContent: data.data,
                loading: false
            })
        } else {
            if (!!data) {
                message.error(data.message)
            } else {
                message.error('接口异常')
                this.setState({
                    loading: false
                })
            }
        }
    }
    componentWillUnmount() {
    }
    getParticulars = (value) => {
        this.setState({
            particularsContent: value
        }, () => {
            this.handleParticularsVisible(true)
        })
    }
    getUpdateConstruction = (value) => {
        this.setState({
            updateConstructionContent: value
        }, () => {
            this.handleUpdateConstructionVisible(true)
        })
    }
    delete = async (e) => {
        let opt = {}
        opt.id = e.nid
        let data = await deleteNews(opt)
        if (!!data && data.code === 0) {
            this.getPages()
            message.success('删除成功')
        } else {
            if (!!data) {
                message.error(data.message)
            } else {
                message.error('接口异常')
                this.setState({
                    loading: false
                })
            }

        }
    }

    columns = [
        {
            title: '公司名称',
            dataIndex: 'companyName',
            search: false,
        },
        {
            title: '联系人姓名',
            dataIndex: 'applyname',
            key:'applyname'
        },
        {
            title: '联系人电话',
            dataIndex: 'tel',
            search: false,
        },
        {
            title: '申请时间',
            dataIndex: 'reg_time',
            valueType: 'date',
        },
        {
            title: '行业类型',
            dataIndex: 'industryType',
            valueType: 'date',
        },
        {
            title: '所属城市',
            dataIndex: 'city',
            valueType: 'date',
        },
        // {
        //     title: '试用产品名称',
        //     dataIndex: 'productName',
        //     key:'productName'
        // },
        // {
        //     title: '职位',
        //     dataIndex: 'position',
        //     search: false,
        // },
        // {
        //     title: '邮箱',
        //     dataIndex: 'email',
        //     search: false,
        // },
        // {
        //     title: '留言',
        //     dataIndex: 'message',
        //     search: false,
        // },
    ];
    onChangeNewList(type, value) {
        if (type == 'current') {
            this.setState({
                current: value.current
            }, () => {
                this.getPages()
            })
        }
    }
    onFinish = async (value) => {
        this.setState({
            current: 1,
            loading: false,
        }, () => {
            this.getPages()
        })
    }
    handleConstructionVisible = async (value) => {
        this.setState({
            constructionVisible: value
        })
    }
    handleParticularsVisible = async (value) => {
        this.setState({
            particularsVisible: value
        })
    }
    handleUpdateConstructionVisible = async (value) => {
        this.setState({
            updateConstructionVisible: value
        })
    }
    render() {
        const { newContent, loading, current, constructionVisible, particularsVisible, particularsContent, updateConstructionVisible, updateConstructionContent, pageContent } = this.state
        const size = 368 / 150
        return (
            <Layout style={{ minHeight: '100%', minWidth: '100%', backgroud: 'none' }} id='homeId'>
                <Top />
                <Layout>
                    <div id='ApplyFor'>
                        <div className="col-lg-1"></div>
                        <div className="col-lg-10">
                            <Row className='choose_new'>
                                <Form name="horizontal_login" layout="inline" onFinish={this.onFinish}>
                                    <Form.Item
                                        name="productName"
                                        label='公司名称'
                                    >
                                        <Input onChange={(value) => { this.setState({ productName: value.target.value }) }} />
                                    </Form.Item>
                                    <Form.Item
                                        name="regTime"
                                        label='申请时间'
                                    >
                                        <DatePicker onChange={(value) => { this.setState({ regTime: moment(value).format('YYYY-MM-DD') != 'Invalid date' ? moment(value).format('YYYY-MM-DD') : '' }) }} />
                                    </Form.Item>
                                    <Form.Item shouldUpdate>
                                        <Button
                                            style={{ background: '#0093D8', color: '#fff' }}
                                            htmlType="submit"
                                        >
                                            搜索
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </Row>
                            <div className='new_Content'>
                                <Table onChange={(value) => this.onChangeNewList('current', value)} columns={this.columns} dataSource={newContent.pageContent} loading={loading} pagination={{ defaultCurrent: current, total: newContent.current, pageSize: 20 }} />
                                {/* <Table dataSource={pageContent} columns={this.columns} /> */}
                            </div>
                        </div>
                        <div className="col-lg-1"></div>
                    </div>
                </Layout>
            </Layout>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ApplyFor))
